<template>
  <!-- 模块标题 -->
  <div class="module-title">{{title}}</div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
<style lang="scss" scoped>
.module-title {
  font-size: 48px;
  font-weight: bold;
  color: #3E3A39;
  line-height: 48px;
  text-align: center;
}
</style>